import {computed, Injectable, signal} from '@angular/core';

@Injectable({ providedIn: 'root' })
// Global UI/app flags as signals. Extend as needed.
export class AppStore {
  // global flags
  private readonly _isLoading = signal<boolean>(false);
  private readonly _locale = signal<string>('fr-FR');
  private readonly _theme = signal<'light' | 'dark'>('light');

  // getters (signals)
  readonly isLoading = this._isLoading.asReadonly();
  readonly locale = this._locale.asReadonly();
  readonly theme = this._theme.asReadonly();

  // derived
  readonly isDark = computed(() => this._theme() === 'dark');

  // setters
  setLoading(v: boolean) { this._isLoading.set(v); }
  setLocale(v: string) { this._locale.set(v); }
  setTheme(v: 'light' | 'dark') { this._theme.set(v); }
}


